import React from 'react'
import { Button } from 'react-bootstrap';
import cx from 'classnames';

//Components
import { AIIcon } from '../Assets/SvgIconComponent/CommonSvgIcon';
import Loader from '../../Loader/Loader';

//Helper
import withStyles from 'isomorphic-style-loader/withStyles';
import { AI_BUTTON_LOADER } from '../../../constants';
import { useSelector } from 'react-redux';

import cs from '../../../components/commonStyle.css';

const AskAIButton = ({ btnText, onClick, currentIndex, containerClass, isButtonVisible, buttonType }) => {

    const aiDataLoading = useSelector(state => state.aiContents.aiResponseLoading);
    const isAiFeatureEnabled = useSelector(state => state.siteSettings.data?.aiTextGeneration);

    return (
        <div className={cx(containerClass, 'isolate')}>
            { isButtonVisible && (
                buttonType === 'loader' ? <Loader
                    show={aiDataLoading}
                    type="button"
                    label={
                        <>
                            <AIIcon className={cx(cs.positionRelative, cs.top3)} />
                            <span>{btnText} AI</span>
                        </>
                    }
                    handleClick={onClick}
                    className={cs.aiAskButton}
                    spinnerColor={AI_BUTTON_LOADER}
                /> :
                    <Button onClick={() => onClick(currentIndex)} className={cs.aiAskButton}>
                        <AIIcon className={cx(cs.positionRelative, cs.top3)} />
                        <span>{btnText} AI</span>
                    </Button >

            )}
        </div>
    )
}

export default (withStyles(cs)(AskAIButton));
